"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactRouterDom = require("react-router-dom");

var _utils = require("../../utils");

var _useStepper = require("./useStepper");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired
} : {};

const Step = ({
  name,
  children
}) => {
  const {
    history
  } = (0, _useStepper.useStepper)();
  return (0, _core.jsx)(_reactRouterDom.Route, (0, _extends2.default)({
    exact: true,
    path: (0, _utils.addPrefix)('/', name)
  }, history), children);
};

exports.Step = Step;
process.env.NODE_ENV !== "production" ? Step.propTypes = propTypes : void 0;
Step.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Step",
  "props": {
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};